// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAwJA6rZLR05-ppgXVZK5qgVnxUnfUsci4",
  authDomain: "xanomega.com",
  projectId: "xanomega-f5822",
  storageBucket: "xanomega-f5822.appspot.com",
  messagingSenderId: "170756173855",
  appId: "1:170756173855:web:d62cf60a55044558ab652a",
};

// Initialize Firebase
initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore()

// Initialize Storage
const storage = getStorage()

// Initialize Functions
const functions = getFunctions()

// Initialize Authentication
const auth = getAuth()

// Initialize Google Authentication
const googleProvider = new GoogleAuthProvider()


export { db, auth, storage, functions, googleProvider }